import { api } from '../api';

const getVehicleFuelTransaction = async (data) => {
  const response = await api({
    url: `Vehicles/GetVehicleFuelTransaction`,
    method: 'GET',
    headers: {
      'x-skip-loader': true,
    },
    params: data,
  });
  return response.data;
};

const downloadVehicleFuelTransactionsFile = async (data) => {
  const response = await api({
    url: `Vehicles/downloadVehicleFuelTransactionsFile`,
    method: 'GET',
    responseType: 'arraybuffer',
    params: data,
  });
  return response.data;
};

const downloadVehicleFuelTransactionsPDFFile = async (data) => {
  const response = await api({
    url: `Vehicles/vehicleFuelTransactionsReport`,
    method: 'GET',
    responseType: 'arraybuffer',
    params: data,
  });
  return response.data;
};

const fuelConsumption = {
  getVehicleFuelTransaction,
  downloadVehicleFuelTransactionsFile,
  downloadVehicleFuelTransactionsPDFFile,
};

export default fuelConsumption;
